import createRouter from '@wtdc/feed-router';
import loadable from '@loadable/component';
import Authorize from '@/business/authorize';
import authUtils from '@/business/authorize/authUtils';
import Locator from '@/utils/locator';
import { NFT_KXD } from '@/constants/common';
import readerCenterApi from '@/api/readercenter';
import channelCenterApi from '@/api/channelcenter';
import Cookie from '@/utils/cookie';
import crypto from '@/utils/crypto';
import Utils from '@/utils/utils';
import { handleDigitalReportQuery } from '@/utils/reportUtil';
import App from './App';

const sessionStorage = window.sessionStorage;

export default createRouter({
  path: '',
  onEnter: async (nextState, history, cb) => {
    const { query } = nextState;

    handleDigitalReportQuery(query, {
      location: nextState.location,
      history,
      replaceLocationQuery: Utils.replaceLocationQuery
    });

    // 保存系统入口参数和cookie
    Locator.save(nextState);

    const isNftRoute = window.location.href.includes('/nft/');
    const isYueLi = window.location.href.includes('STAMP_TYPE=19'); // 上邮月里青山淡如画
    const isDouLuo = window.location.href.includes('/douluo/');
    /** 小睿伴学h5会员支付页 */
    const isRuiMember = window.location.pathname.startsWith('/rayh5/ruimember/');
    const isEvaluation = window.location.pathname.startsWith('/rayh5/evaluation/');
    // 中山舰
    const isExhibit = window.location.href.includes('exhibit');

    Promise.resolve().then(() => {
      Utils.replaceLocationQuery(history, location, query, {
        traceId: undefined
      });
    });

    // 小睿伴学h5会员支付页 授权放到下一级路由
    if(isRuiMember || isEvaluation || isExhibit) {
      return cb();
    }

    const originCookie = Cookie.get();
    if(isNftRoute && !isYueLi) { //上邮月里青山淡如画不清cookie
      if(originCookie.officialAccountsId && originCookie.officialAccountsId !== '999') {
        authUtils.removeCookieUser();
      }
    }

    // 判断是否NFT二维码
    if(query.sceneId) {
      channelCenterApi.isKXDBySceneId({ sceneId: query.sceneId }).then((data) => {
        sessionStorage.setItem(NFT_KXD, data);
      });
    }

    // 订阅授权, nft 不使用静默授权
    if(!isYueLi) { // 上邮月里青山淡如画不走这里授权
      await Authorize.initAuthorize({
        defaultAuthorize: !isNftRoute && !isDouLuo && authUtils.browser().wechat,
        snsapiBase: !isDouLuo
      });
    }
    const newCookie = Cookie.get();
    if(isNftRoute && newCookie.officialAccountsId !== '999' && originCookie.officialAccountsId === '999') {
      const authInfo = localStorage.getItem('authInfo') || {};
      let { originalAvatar, avatar } = JSON.parse(authInfo);
      if(originalAvatar) {
        const sliceIndex = originalAvatar.lastIndexOf('/');
        originalAvatar = originalAvatar.slice(0, sliceIndex) + '/0';
      }
      localStorage.setItem('wechatAvatar', originalAvatar || avatar);
      // 合并999 23公众号用户
      readerCenterApi.miniGzhUserRelate({
        ciphertext: crypto.aesEncrypt({
          miniOfficialAccountsId: originCookie.officialAccountsId,
          miniWechatUserId: originCookie.wechatUserId,
          gzhOfficialAccountsId: newCookie.officialAccountsId,
          gzhWechatUserId: newCookie.wechatUserId
        })
      });

      Cookie.setItem(originCookie);
    }

    cb();

  },
  getComponent: () => App,
  getChildRoutes: () => [
    {
      path: '/rayh5',
      component: createRouter({
        getChildRoutes: () => [
          {
            path: '/home',
            component: loadable(() => {
              return import('./Home');
            })
          },
          {
            path: '/book',
            component: loadable(() => {
              return import('./BookService');
            })
          },
          {
            path: '/custombook',
            component: loadable(() => {
              return import('./CustomBook');
            })
          },
          {
            path: '/mine',
            component: loadable(() => {
              return import('./Mine');
            })
          },
          {
            path: '/login',
            component: loadable(() => {
              return import('./Login/index');
            })
          },
          {
            path: '/library',
            component: loadable(() => {
              return import('./LibraryBook/index');
            })
          },
          {
            path: 'introduce',
            component: loadable(() => {
              return import('./RayIntroduce/index');
            })
          },
          {
            path: '/feedback',
            component: loadable(() => {
              return import('./FeedBack/index');
            })
          },
          {
            path: '/applet',
            component: loadable(() => {
              return import('./Applet/index');
            })
          },
          {
            path: '/auth',
            component: loadable(() => import('./Auth/index'))
          },
          {
            path: '/nft',
            component: loadable(() => {
              return import('./NftHome/index');
            })
          },
          {
            path: '/nft404',
            component: loadable(() => {
              return import('./Nft404/index');
            })
          },
          {
            path: '/member',
            component: loadable(() => {
              return import('./Member/index');
            })
          },
          {
            path: '/xiaoruiedu',
            component: loadable(() => {
              return import('./RayEduRedirect/index');
            })
          },
          {

            path: '/landpage',
            component: loadable(() => {
              return import('./LandPage/index');
            })
          },
          {
            path: '/CodeGether',
            component: loadable(() => {
              return import('./CodeGether/index');
            })
          },
          {
            path: '/douluo',
            component: loadable(() => {
              return import('./DLHome/index');
            })
          },
          {
            path: '/webview',
            component: loadable(() => {
              return import('./Webview');
            })
          },
          {
            path: '/douyiAuthorization',
            component: loadable(() => {
              return import('./DouyiAuthorization');
            })
          },
          {
            path: '/multivariate',
            component: loadable(() => {
              return import('./Multivariate');
            })
          },
          {
            path: '/magicube',
            component: loadable(() => {
              return import('./MagicCube');
            })
          },
          {
            path: '/equity',
            component: loadable(() => {
              return import('./Equity');
            })
          },
          {
            path: '/learning',
            component: loadable(() => {
              return import('./LearningAbility');
            })
          },
          {
            path: '/ruimember/t:temp',  //小睿伴学H5会员支付页
            component: loadable(() => {
              return import('./RuiMember');
            })
          },
          {
            path: '/evaluation', // 专业测评统一入口
            component: loadable(() => {
              return import('./Evaluation');
            })
          },
          {
            path: '/activity', // 小睿伴学会员活动
            component: loadable(() => {
              return import('./ActivityPage');
            })
          },
          {
            path: '/bookanswer',
            component: loadable(() => {
              return import('./BookAnswer/index');
            })
          },
          {
            path: '/newapplet',
            component: loadable(() => {
              return import('./NewApplet/index');
            })
          },
          {
            path: '/bookshelf',
            component: loadable(() => {
              return import('./BookShelf/index');
            })
          },
          {
            path: '/advert',
            component: loadable(() => {
              return import('./AdPage/index');
            })
          },
          {
            path: '/inviteinwanjuan',
            component: loadable(() => {
              return import('./InviteInWanJuan/index');
            })
          },
          {
            path: ':mode/exhibit',
            component: loadable(() => {
              return import('./Exhibits/index');
            })
          },
          {
            path: '/quarterreport',
            component: loadable(() => {
              return import('./QuarterReport/index');
            })
          },
          {
            path: 'microLecture',
            component: loadable(() => {
              return import('./MicroLecture/index');
            })
          },
          {
            path: '/qr_check', // 二维码检测
            component: loadable(() => {
              return import('./QRCheck/index');
            })
          },
          {
            path: '/bindUser', // 绑定用户关西
            component: loadable(() => {
              return import('./BindUser/index');
            })
          }
        ]
      })
    }
  ]
});
